import {
  ICliente,
  IFilter,
  ILayerMapaPersonalizado,
  IPopulate,
  IReporteGenerico,
} from 'modelos/src';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import mapboxgl from 'mapbox-gl';

import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { TipoMapaBase } from '../../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { LoginService } from '../../../login/login.service';
import { MapaFacilV2Service } from '../../../../auxiliares/mapbox/mapa-facil-v2.service';

@Component({
  selector: 'app-mapa-activos',
  templateUrl: './mapa-activos.component.html',
  styleUrl: './mapa-activos.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MapaActivosComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  private helper = inject(HelperService);
  private mapaFacilV2Service = inject(MapaFacilV2Service);
  private cdr = inject(ChangeDetectorRef);

  public ctrl = false;

  //Activos
  public reportesActivos?: IReporteGenerico[] = [];
  public reporteActivos?: IReporteGenerico;
  public reportesActivos$?: Subscription;
  public clientePropio: ICliente = LoginService.getClientePropio();

  // Activos
  private activosMostrar: boolean = true;

  // Entidades permitidas para re-aplicar datos al cambiar capa base. Las entidades pueden ser las que están presentes en MapaFacilV2Data
  public allowedTypes: string[] = ['activos'];

  //POPULATE
  private populateActivos: IPopulate[] = [
    {
      path: 'activo',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'grupos',
      select: 'nombre',
    },
  ];

  // Mapa
  public map: mapboxgl.Map | null = null;

  //////////////////////////////////////////////////////////////////
  //MAPAS A MOSTRAR
  public readonly TIPO_MAPA_BASE_KEY = 'tipoMapaBaseActivosComponent'; //Key para ver el mapa base que está en el local Storage
  public tipoMapaBase: TipoMapaBase =
    localStorage.getItem(this.TIPO_MAPA_BASE_KEY) || 'osm'; //Mapa base que está en el local Storage
  public mapasPersonalizados: ILayerMapaPersonalizado[] = []; //Mapas personalizados del cliente
  public baseLayer: any;

  /// Activos
  public async listarActivos(): Promise<void> {
    try {
      const filter: IFilter<IReporteGenerico> = { tipoEntidad: 'Activo' };
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        populate: JSON.stringify(this.populateActivos),
        includeChildren: true,
      };

      this.reportesActivos$?.unsubscribe();
      this.reportesActivos$ = this.lista2
        .ultimosReportesGenericos(query, 30)
        .subscribe((data) => {
          this.reportesActivos = data.datos;
          this.addMarkersActivos();
          // OnPush: Marcar para change detection después del polling
          this.cdr.markForCheck();
        });
    } catch (error: any) {
      this.helper.notifError('Error al listar activos');
    }
  }

  /**
   * Actualiza el mapa con los activos
   *
   * Nueva implementación usando MapaFacilV2Service:
   * - Ya no necesitamos convertir a MarkerMapa[]
   * - Pasamos los reportes directamente
   * - El ActivosLayerManager se encarga de todo
   */
  public addMarkersActivos() {
    if (!this.mapaFacilV2Service.isReady()) {
      console.warn('⚠️ Mapa no está listo todavía, esperando...');
      return;
    }

    if (this.reportesActivos && this.activosMostrar) {
      // API simplificada: pasamos los reportes directamente
      this.mapaFacilV2Service.updateData({
        activos: this.reportesActivos,
      });
    } else {
      // Si no hay activos o están ocultos, limpiar
      this.mapaFacilV2Service.updateData({
        activos: [],
      });
    }
  }

  public async onActivosChange() {
    this.activosMostrar = !this.activosMostrar;
    this.addMarkersActivos();
  }

  /**
   * Callback cuando el mapa está listo
   */
  public onMapReady(map: mapboxgl.Map): void {
    this.map = map;

    // Actualizar activos cuando el mapa esté listo
    this.addMarkersActivos();
    // OnPush: Marcar para check por si el mapa se carga después del polling
    this.cdr.markForCheck();
  }

  async ngOnInit() {
    if (this.clientePropio?.mapLayers) {
      this.mapasPersonalizados = this.clientePropio.mapLayers;
    }

    // Cargar activos (el mapa se actualizará cuando esté listo)
    await this.listarActivos();
  }

  ngOnDestroy() {
    this.reportesActivos$?.unsubscribe();

    // IMPORTANTE: Limpiar datos del servicio para evitar que persistan al cambiar de mapa
    // El servicio es singleton, por lo que mantiene datos entre componentes
    this.mapaFacilV2Service.clearAllData();
  }
}
